const callLogsDetails  = () => {
    // let callDetails = [{"dateTime": "31 Jul 2024 11:53:38", "duration": 0, "name": "Nitesh 2 Park+", "phoneNumber": "+919560494963", "rawType": 3, "timestamp": "1722407018198", "type": "MISSED"}, {"dateTime": "31 Jul 2024 11:52:17", "duration": 15, "name": "Kanishk park+", "phoneNumber": "+919837739092", "rawType": 2, "timestamp": "1722406937611", "type": "OUTGOING"}, {"dateTime": "31 Jul 2024 11:50:26", "duration": 12, "name": "Nitesh 2 Park+", "phoneNumber": "+919560494963", "rawType": 1, "timestamp": "1722406826167", "type": "INCOMING"}, {"dateTime": "31 Jul 2024 11:49:02", "duration": 8, "name": "Nitesh 2 Park+", "phoneNumber": "+919560494963", "rawType": 2, "timestamp": "1722406742835", "type": "OUTGOING"}];
    // let callDetails = [];
    // let webView = window.localStorage.webview;
    //
    // const handleMessage = (event) => {
    //     const message = event.data;
    //     console.log("Call Log Event Response "+JSON.stringify(message))
    //     if (message) {
    //         callDetails = message;
    //         window.removeEventListener('message', handleMessage); // Clean up event listener
    //         resolve(callDetails);
    //     }
    // };
    //
    // if(webView !== undefined && webView == 'true') {
    //     console.log("Call Log Event")
    //     const message = {
    //         event_name: 'call_log'
    //     }
    //     const nativeObject = window?.ReactNativeWebView;
    //     if (nativeObject !== undefined) {
    //         nativeObject.postMessage(JSON.stringify(message));
    //         window.addEventListener('message', handleMessage)
    //     }
    // }
    //
    // return callDetails;

    return new Promise((resolve, reject) => {
        let callDetails = [];
        let webView = window.localStorage.getItem('webview'); // Use getItem to retrieve data from localStorage

        const handleMessage = (event) => {
            const message = event.data;
            console.log("Call Log Event Response: " + JSON.stringify(message));
            if (message) {
                callDetails = message;
                window.removeEventListener('message', handleMessage); // Clean up event listener
                resolve(callDetails);
            }
        };

        if (webView !== undefined && webView === 'true') {
            console.log("Call Log Event Triggered");
            const message = {
                event_name: 'call_log'
            }
            const nativeObject = window?.ReactNativeWebView;
            if (nativeObject !== undefined) {
                nativeObject.postMessage(JSON.stringify(message));
                window.addEventListener('message', handleMessage);
            }
        }
    });
}

export default callLogsDetails;